import { authEpic } from './auth';
import { combineEpics } from 'redux-observable';

export const publicRootEpic = combineEpics(authEpic);
